import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import {getNotification} from '~/selectors/NotificationSelectors';

import {Button, Stack} from '@customink/pigment-react';
import Notification from '~/components/Notification';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export function MinQtyInternationalShippingNotification(props) {
  const notification = useSelector(getNotification);

  const handleEditQuantity = () => {
    notification?.onConfirm?.();
    props.dismiss();
  };

  const handleCancel = () => {
    notification?.onCancel?.();
    props.dismiss();
  };

  return (
    <Notification
      {...props}
      title="Minimum Quantity Not Met For International Shipping">
      <p>Increase your quantity to 6 or more for international shipping.</p>
      <Stack className="notification-stack">
        {notification?.onConfirm && (
          <Button
            size="large"
            className="notification-cta"
            variant="secondary"
            onClick={handleEditQuantity}>
            Edit Quantity
          </Button>
        )}
        <Button
          size="large"
          className="notification-cta"
          variant="link"
          onClick={handleCancel}>
          Cancel
        </Button>
      </Stack>
    </Notification>
  );
}

MinQtyInternationalShippingNotification.displayName =
  'MinQtyInternationalShippingNotification';

const propTypes = {
  confirm: PropTypes.func,
  dismiss: PropTypes.func
};

MinQtyInternationalShippingNotification.propTypes = propTypes;

export default MinQtyInternationalShippingNotification;
